export default __webpack_public_path__ + "static/media/clark-street-mercantile.43bb4270.jpg";